export default analytics = (window as any)
  .analytics as SegmentAnalytics.AnalyticsJS;
